import React, {useContext, useEffect, useRef, useState} from "react";
import {Layout, Tooltip} from "antd";
import "./LocationContent.module.scss";
import styles from "./LocationContent.module.scss";
import {
    AreaDataset,
    CloseIcon,
    DistanceIcon,
    LayerIcon,
    longdo,
    longdoKey,
    ZoneColorLevel,
    ZoneType,
} from "./location.const";
import {calculateDate, checkDateBeforeNow,} from "./location.util";
import * as GroupAPI from "../../../service/group.service";
import {checkEmpty, getUrlHttp} from "src/service/util.service";
import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import placeholderImg from "src/assets/png/popup-placeholder.png";
import PopupZones from "./PopupZones";
import {AppContext} from "../../context/App.context";
import {UserAPIEndpoint} from "src/service/user.service";

const { Header, Footer, Sider, Content } = Layout;

const LocationContent = (props: any) => {
  const mapElement = useRef(null);
  const { t } = useTranslation();
  const appContext: any = useContext(AppContext);
  const [map, setMap]: any = useState(null);
  const [openPopup, setOpenPopup]: any = useState(false);
  const [markerPosition, setMarkerPostion]: any = useState(null);
  const [userLocation, setUserLocation]: any = useState(null);
  const [locationList, setLocationList]: any = useState(null);
  const [popupBanner, setPopupBanner]: any = useState(null);
  const [openPopupMenu, setopenPopupMenu]: any = useState(false);
  const [zoneList, setZoneList]: any = useState(null);
  const [currentZone, setCurrentZone]: any = useState(null);
  const [clickMore, setClickMore]: any = useState(false);

  const [userID, setUserID]: any = useState(null);
  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });
  const setDataUser = async () => {
    // let token = Auth.getToken();
    // if (!checkEmpty(token)) {
    //   let userdata = parseJwt(token);
    //   console.log("userdata", userdata);
    //   setUserID(userdata.userID);
    // }
    if(checkEmpty(appContext?.userId)){
      const me = await api.get(UserAPIEndpoint.Me);
      console.log("me",me);
      setUserID(me.id);
    }
  };

  const initLocation = () => {
    let lang = localStorage.getItem("lang");
    if (!lang) {
      lang = "en";
    }
    navigator.geolocation.getCurrentPosition(setLocation);
    if (mapElement && mapElement?.current) {
      let map = new longdo.Map({
        placeholder: mapElement.current,
        ui: longdo.UiComponent.Mobile,
        language: lang,
      });
      map.Ui.Zoombar.visible(false);
      map.Ui.Geolocation.visible(false);
      map.Ui.LayerSelector.visible(false);
      map.Ui.Crosshair.visible(false);
      map.Ui.Scale.visible(false);
      map.Ui.Fullscreen.visible(false);
      map.zoom(14, true);
      map.Event.bind("overlayClick", handleClickOverLay);
      console.log("map", map);
      setMap(map);
    }
  };
  const setLocation = (pos: any) => {
    setUserLocation({ lon: pos?.coords?.longitude, lat: pos?.coords?.latitude });
  };

  useEffect(() => {
    console.log("id => ",props.id," type => ",props.type);
    
    setDataUser()
    initLocation();
  }, []);

  useEffect(() => {
    console.log("zxy123 props.groupId => ",props.groupId);
    console.log("zxy123 props.groupType => ",props.groupType);
    console.log("zxy123 userID => ",userID);
    console.log("zxy123 if => ",props.groupId && props.groupType && userID != null);
    
    
    if (props.groupId && userID != null ) {
      getMemberLocation();
      getZoneList();
    }
    // if (props.groupId && props.groupType && userID != null ) {
    //   getMemberLocation();
    //   getZoneList();
    // }
    
  }, [userID]);

  useEffect(() => {
    if (userLocation?.lat && userLocation?.lon && map) {
      map.location({ lon: userLocation.lon, lat: userLocation.lat }, true);
      var dot = new longdo.Dot(
        {
          lon: userLocation.lon,
          lat: userLocation.lat,
        },
        {
          lineWidth: 20,
          lineColor: ZoneColorLevel.UserPosition.line,
          weight: "top",
        }
      );
      var dotBorder = new longdo.Dot(
        {
          lon: userLocation.lon,
          lat: userLocation.lat,
        },
        {
          lineWidth: 25,
          lineColor: ZoneColorLevel.DotBorder.line,
          weight: "top",
        }
      );
      map.Overlays.add(dot);
      map.Overlays.add(dotBorder);
    }
  }, [userLocation]);

  const getZoneList = async () => {
    const { data } = await GroupAPI.zoneList();
    console.log("ZoneList", data);
    setZoneList(data);
  };
  const getMemberLocation = async () => {
    const { data } = await GroupAPI.memberLocation(props.groupId);
    console.log("Groups", data);
    let locationList = clusterLocation(data);
    console.log("locationList", locationList);
    setLocationList(locationList);
  };
  const clusterLocation = (membersLocation: any) => {
    const groupType = props?.groupType;
    const groupId = props?.groupId;
    let locations: any = [];
    const memberList = membersLocation?.members;
    memberList?.forEach?.((mem: any) => {
      let userInfo = mem?.user;
      let userId = userID;
      if (userId === userInfo?.id) {
        return;
      }
      // let preference = userInfo.userGroupPrefer;
      // if (!preference) {
      //   return;
      // }
      // let allowLocationGroup = preference.find((prefer: any) => {
      //   return !prefer.type && prefer.groupId === groupId;
      // });
      // if (!allowLocationGroup) {
      //   let allowLocation = preference.find((prefer: any) => {
      //     return (
      //       prefer.type === groupType &&
      //       prefer.value === "true" &&
      //       !prefer.groupId
      //     );
      //   });
      //   if (!allowLocation) {
      //     return;
      //   }
      // } else {
      //   if (allowLocationGroup?.value !== "true") {
      //     return;
      //   }
      // }
      let poi = userInfo?.userPois;
      if (poi && poi[0].lat && poi[0].long) {
        let duplicateLo = locations.find((item: any) => {
          return item?.lat === poi[0].poiLat && item?.long === poi[0].poiLong;
        });
        if (duplicateLo) {
          duplicateLo.imgUrl.push(userInfo?.imageProfileURL);
          duplicateLo.checkedInList.push({
            userName: userInfo?.firstname,
            checkedIn: poi[0].createdAt,
          });
        } else {
          let obj = {
            lat: poi[0].poiLat,
            long: poi[0].poiLong,
            imgUrl: [userInfo?.imageProfileURL],
            aoi: poi[0].name,
            address: poi[0].address,
            time: poi[0].createdAt,
            ooi: poi[0].ooiID,
            checkedInList: [
              {
                userName: userInfo?.firstname,
                checkedIn: poi[0].createdAt,
              },
            ],
          };
          locations.push(obj);
        }
      }
    });
    return locations;
  };
  const renderMemberLocation = () => {
    if (locationList && map) {
      locationList.forEach((local: any) => {
        let marker = new longdo.Marker(
          { lon: local?.long, lat: local?.lat },
          {
            rotate: 0,
            icon: {
              // html: renderMarker(local?.imgUrl),
              html: renderProfileImg(local?.imgUrl),
            },
          }
        );
        map.Overlays.add(marker);
      });
    }
  };
  const renderMarker = (imgList: any) => {
    if (imgList?.length > 1) {
      return `
      <div>
        <svg width="18.809" height="26.904"><path fill="#006a95" d="M16.055 2.755a9.4 9.4 0 0 0-13.3 0c-3.31 3.309-3.678 9.54-.878 13.284L9.405 26.9l7.523-10.865c2.808-3.74 2.436-9.971-.873-13.28zm-6.558 9.663a3.1 3.1 0 1 1 3.1-3.1 3.1 3.1 0 0 1-3.101 3.1z"/></svg>
        <div style="border-radius: 18px; margin-top: -40px;margin-left: 25px; background-color: #fff; display: flex;cursor: pointer;padding: 2px;box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);">
          ${renderProfileImg(imgList)}
        </div>
      </div>`;
    } else {
      return `
      <div>
        <svg width="18.809" height="26.904"><path fill="#006a95" d="M16.055 2.755a9.4 9.4 0 0 0-13.3 0c-3.31 3.309-3.678 9.54-.878 13.284L9.405 26.9l7.523-10.865c2.808-3.74 2.436-9.971-.873-13.28zm-6.558 9.663a3.1 3.1 0 1 1 3.1-3.1 3.1 3.1 0 0 1-3.101 3.1z"/></svg>
        <div style="border-radius: 50%; margin-top: -5px; background-color: #fff; display: flex;cursor: pointer;">
          ${renderProfileImg(imgList)}
        </div>
      </div>`;
    }
  };
  const renderProfileImg = (imgList: any) => {
    return `
    ${
      imgList[0]
        ? `<div style="border: 3px solid #fff; border-radius: 50%; width: 50px; height: 50px; background-image: url('${getUrlHttp(imgList[0])}'); background-size: cover;"></div>`
        : ``
    }
    ${
      imgList[1]
        ? `<div style="border: 3px solid #fff; border-radius: 50%; width: 50px; height: 50px; background-image: url('${getUrlHttp(imgList[1])}'); background-size: cover; margin-left: -20px;"></div>`
        : ``
    }
    ${
      imgList?.length > 2
        ? `<div style="border: 3px solid #fff; border-radius: 50%; width: 50px; height: 50px; background-color: #006a95; margin-left: -20px;">
            <p style="font-size: 1.25rem; color: #fff; font-weight: bold; text-align: center; margin-top: 10px;">+${
              imgList?.length - 2
            }</p>
        </div>`
        : ``
    }
    `;
  };

  useEffect(() => {
    renderMemberLocation();
  });

  const handleClickOverLay = (overlay: any) => {
    console.log("handleClickOverLay");
    let location = overlay.location();
    setMarkerPostion(location);
    setOpenPopup(true);
  };

  const renderPopup = () => {
    console.log("renderPopup");
    if (!userLocation || !markerPosition) {
      return;
    }
    let localInfo = locationList.find((item: any) => {
      return (
        item?.lat === markerPosition?.lat && item?.long === markerPosition?.lon
      );
    });
    let distance = longdo.Util.distance([userLocation, markerPosition]);
    let distanceKm = (distance / 1000).toFixed(3);
    if (!localInfo) {
      return;
    }
    console.log("localInfo", localInfo);
    return (
      <div
        className={styles.popupLocation}
        style={{ bottom: `${openPopupMenu ? "10%" : "4%"}` }}
      >
        <div
          className={styles.locationBanner}
          style={
            !popupBanner
              ? {
                  // height: `${0.12 * screen.height}px`,
                  height: 100,
                  backgroundPosition: "center center",
                  backgroundImage: `url(${placeholderImg})`,
                  backgroundSize: "80px 80px",
                  backgroundRepeat: "no-repeat",
                  backgroundColor: "#b3b3b3",
                }
              : {
                  // height: `${0.12 * screen.height}px`,
                  height: 100,
                  backgroundImage: `url(${popupBanner})`,
                  backgroundSize: "cover",
                }
          }
        >
          <div className={styles.closeBtn} onClick={handleClickCloseBtn}>
            {CloseIcon()}
          </div>
        </div>
        <div className={styles.locationInfo}>
          <div className={styles.details}>
            {localInfo?.aoi && <p className={styles.name}>{localInfo?.aoi}</p>}
            <div className={styles.district}>
              <p>{localInfo?.address}</p>
            </div>
            <div className={styles.distance}>
              {DistanceIcon()}
              <p>
                {distanceKm} {t("Km")}
              </p>
            </div>
          </div>
          <div className={styles.profile}>
            {localInfo?.imgUrl && renderPopupProfile(localInfo?.imgUrl)}
            {!clickMore &&
              localInfo?.checkedInList &&
              renderCheckedInList(localInfo?.checkedInList)}
            {clickMore &&
              localInfo?.checkedInList &&
              renderCheckedInListMore(localInfo?.checkedInList)}
          </div>
        </div>
      </div>
    );
  };
  const onClickMore = () => {
    setClickMore(true);
  };
  function renderCheckedInList(checkedInList: any) {
    return (
      <div style={{ textAlign: "center" }}>
        {checkedInList[0] ? (
          <Tooltip
            placement="top"
            title={
              checkedInList[0].userName +" "+
              t("Checked in") +" "+
              calculateDate(checkedInList[0].checkedIn, t)
            }
            color="#0f4c82"
          >
            <div className={styles.checkTime}>
              <div
                style={{
                  maxWidth: 100,
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >{`${checkedInList[0].userName}`}</div>
              <div style={{ marginLeft: 2 }}>{`${t(
                "Checked in"
              )} ${calculateDate(checkedInList[0].checkedIn, t)}`}</div>
            </div>
          </Tooltip>
        ) : null}
        {checkedInList[1] ? (
          <Tooltip
            placement="top"
            title={
              checkedInList[1].userName +" "+
              t("Checked in") +" "+
              calculateDate(checkedInList[1].checkedIn, t)
            }
            color="#0f4c82"
          >
            <div className={styles.checkTime}>
              <div
                style={{
                  maxWidth: 100,
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >{`${checkedInList[1].userName}`}</div>
              <div style={{ width: "100%", marginLeft: 2 }}>{`${t(
                "Checked in"
              )} ${calculateDate(checkedInList[1].checkedIn, t)}`}</div>
            </div>
          </Tooltip>
        ) : null}
        {checkedInList.length > 2 ? (
          <div
            className={styles.checkTime}
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              onClickMore();
            }}
          >
            View more
          </div>
        ) : null}
      </div>
    );
  }
  function renderCheckedInListMore(checkedInList: any) {
    return (
      <div style={{ textAlign: "center", height: 160, overflowY: "scroll" }}>
        {checkedInList?.map((member: any, index: number) => (
          <Tooltip
            placement="top"
            title={
              member?.userName +" "+
              t("Checked in") +" "+
              calculateDate(member?.checkedIn, t)
            }
            color="#0f4c82"
          >
            <div key={index} className={styles.checkTime}>
              <div
                style={{
                  maxWidth: 100,
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {member?.userName}
              </div>
              <div style={{ width: "100%", marginLeft: 2 }}>
                {t("Checked in")} {calculateDate(member?.checkedIn, t)}
              </div>
            </div>
          </Tooltip>
        ))}
      </div>
    );
  }
  function handleClickCloseBtn() {
    console.log("handleClickCloseBtn");
    setOpenPopup(false);
    setMarkerPostion(null);
    setPopupBanner(null);
    setClickMore(false);
  }
  function renderPopupProfile(imgList: any) {
    console.log("renderPopupProfile");
    return (
      <div className={styles.proflieImgWrapper}>
        {imgList[0] ? (
          <div
            className={styles.imgCircle}
            style={{
              backgroundImage: `url('${getUrlHttp(imgList[0])}')`,
              backgroundSize: "cover",
            }}
          ></div>
        ) : null}
        {imgList[1] ? (
          <div
            className={styles.imgCircle}
            style={{
              backgroundImage: `url('${getUrlHttp(imgList[1])}')`,
              backgroundSize: "cover",
              marginLeft: "-20px",
            }}
          ></div>
        ) : null}
        {imgList?.length > 2 ? (
          <div
            className={styles.imgCircle}
            style={{
              backgroundColor: "#006a95",
              marginLeft: "-20px",
            }}
          >
            <p className={styles.imgLength}>+{imgList?.length - 2}</p>
          </div>
        ) : null}
      </div>
    );
  }

  function handleClickZoneCloseBtn() {
    setopenPopupMenu(false);
    deleteZone();
  }
  function deleteZone() {
    if (!currentZone) {
      return;
    }
    map.Tags.clear();
    currentZone.forEach((zone: any) => {
      if (zone?.type === ZoneType.Point) {
        map.Overlays.remove(zone?.overlay);
      } else if (zone?.type === ZoneType.Area) {
        map.Overlays.unload(zone?.overlay);
      }
    });
    setCurrentZone(null);
  }

  //check tags
  function isTags(checkedInList: string) {
    const tags = ["restaurant","hospital","hotel","convenience_store","hospital","gas_station","post","bank"];
    const found = tags.find(element => element.toLowerCase() === checkedInList.toLowerCase());
    return !(!found)
  }
  const handleSelectZone = async (zoneInfo: any) => {
    console.log("zoneInfo => ",zoneInfo);
    const m = 300

    let overLayList: any = [];
    deleteZone();
    if(zoneInfo?.zoneLocations?.length <= 0 && !isTags(zoneInfo?.name)){
      return
    }
 
    if(isTags(zoneInfo?.name)){
      if(!userLocation?.lon || !userLocation?.lat){
        return
      }
      // const response = await fetch(`https://api.longdo.com/POIService/json/search?&lon=${userLocation?.lon}&lat=${userLocation?.lat}&span=250m&limit=1000&key=${longdoKey}`);
      console.log("api => ",`https://api.longdo.com/POIService/json/search?tag=${zoneInfo?.name}&lon=${userLocation?.lon}&lat=${userLocation?.lat}&span=${zoneInfo?.span}m&limit=100000&key=${longdoKey}`);
      
      const meter = (zoneInfo?.span != null && zoneInfo?.span != undefined) ? zoneInfo?.span : 500
      const response = await fetch(`https://api.longdo.com/POIService/json/search?tag=${zoneInfo?.name}&lon=${userLocation?.lon}&lat=${userLocation?.lat}&span=${meter}m&limit=1000&key=${longdoKey}`);
      const dataRes = await response.json();
      // console.log("dataRes => ",dataRes);
      
      

      let radius = (meter) / longdo.Util.longitudeLength(userLocation.lat);
      // let radius = (m+(m*10/100)) / longdo.Util.longitudeLength(userLocation.lat);
      var circle = new longdo.Circle(
          {
            lon: userLocation?.lon,
            lat: userLocation?.lat,
          },
            radius,
            {
              lineWidth: 0,
              lineColor: "#086A95",
              fillColor: "rgba(8, 106, 149, 0.1)",
              weight: 2,
            }
      );
      map.Overlays.add(circle);
      overLayList.push({ overlay: circle, type: ZoneType.Point });
            
      {dataRes.data?.map((item: any) => {
        var markerText = new longdo.Marker({ lon: item.lon, lat: item.lat },
          {
            // title: 'Custom Marker',
            icon: {
              html: '<div style="font-size: 16px;color: #000;font-weight: italic; white-space: nowrap; text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;">'+item?.name+'</div>',
              offset: { x: -10, y: 17 }
            },
            // popup: {
            //   html: '<div style="background: #eeeeff;">popup</div>'
            // },
            visibleRange: {  min: 18, max: 26  }
          });

          map.Overlays.add(markerText);
          overLayList.push({ overlay: markerText, type: ZoneType.Point});

        var markIcon = new longdo.Marker({ lon: item.lon, lat: item.lat },
          {
            icon: {
              // url: zoneInfo?.iconImageURL,//'https://cdn-icons-png.flaticon.com/24/3170/3170733.png'
              // html:`<img src="${zoneInfo?.iconImageURL}" width="20" height="20">`,
              html:`<img src="https://mmmap15.longdo.com/mmmap/images/icons_big/${item?.icon}" width="20" height="20">`,
              offset: { x: 10, y: 7 }
            },
            // popup: {
            //   html: '<div style="background: #eeeeff;">popup</div>'
            // },
            visibleRange: { min: 10, max: 20  },
            weight: longdo.OverlayWeight.Top,
          });

          
          map.Overlays.add(markIcon);
          overLayList.push({ overlay: markIcon, type: ZoneType.Point });

        // map.Tags.add('%C', { area: '10' });
        // map.Tags.add('Bank', { area: '10' });
        // map.Tags.add('Post', { area: '10' });
      })}
     
    }else{
        zoneInfo?.zoneLocations.forEach( (zone: any) => {
          if (!zone?.publishedAt || !zone?.lat || !zone?.long) {
            return;
          }

          let isExpired = checkDateBeforeNow(zone?.expiredAt);
          let isPublished = checkDateBeforeNow(zone?.publishedAt);
          if (isExpired || !isPublished) {
            return;
          }
          let level: any = zone?.level ? zone?.level : 0;
          console.log("level", level);
          let ZoneColorLevellevel: any = setZoneColorLevellevel(level);
          if (zone?.supportType === ZoneType.Point) {
            if (zone?.area && zone?.area > 0) {
              let radius =
                (zone?.area * 1000) / longdo.Util.longitudeLength(zone?.lat);
              var circle = new longdo.Circle(
                {
                  lon: zone?.long,
                  lat: zone?.lat,
                },
                radius,
                {
                  lineWidth: 0,
                  lineColor: ZoneColorLevel.Circle.line,
                  // fillColor: ZoneColorLevel[level].fill,
                  fillColor: ZoneColorLevellevel?.fill,
                  weight: 2,
                }
              );
              map.Overlays.add(circle);
              overLayList.push({ overlay: circle, type: ZoneType.Point });
            }
            var dot = new longdo.Dot(
              {
                lon: zone?.long,
                lat: zone?.lat,
              },
              {
                lineWidth: 20,
                // lineColor: ZoneColorLevel[level].line,
                lineColor: ZoneColorLevellevel?.line,
                weight: 5,
              }
            );
            var dotBorder = new longdo.Dot(
              {
                lon: zone?.long,
                lat: zone?.lat,
              },
              {
                lineWidth: 25,
                lineColor: ZoneColorLevel.DotBorder.line,
                weight: 4,
              }
            );
            map.Overlays.add(dot);
            map.Overlays.add(dotBorder);
            overLayList.push({ overlay: dot, type: ZoneType.Point });
            overLayList.push({ overlay: dotBorder, type: ZoneType.Point });
          } else if (zone?.supportType === ZoneType.Area) {
            var area = new longdo.Overlays.Object(zone?.geoCode, AreaDataset, {
              // lineColor: ZoneColorLevel[level].line,
              // fillColor: ZoneColorLevel[level].fill,
              lineColor: ZoneColorLevellevel?.line,
              fillColor: ZoneColorLevellevel?.fill,
            });
            map.Overlays.load(area);
            overLayList.push({ overlay: area, type: ZoneType.Area });
          }
        });
    }
    setCurrentZone(overLayList);
  };
  function setZoneColorLevellevel(level: number) {
    let ZoneColorLevellevel: any;
    if (level === 1) {
      ZoneColorLevellevel = ZoneColorLevel[1];
    } else if (level === 2) {
      ZoneColorLevellevel = ZoneColorLevel[2];
    } else if (level === 3) {
      ZoneColorLevellevel = ZoneColorLevel[3];
    } else if (level === 4) {
      ZoneColorLevellevel = ZoneColorLevel[4];
    } else if (level === 5) {
      ZoneColorLevellevel = ZoneColorLevel[5];
    }
    return ZoneColorLevellevel;
  }
  function renderMenuBtn() {
    return (
      <div className={styles.locationMenuBtn} onClick={handleClickMenuBtn}>
        {LayerIcon()}
      </div>
    );
  }
  function handleClickMenuBtn() {
    setopenPopupMenu(true);
  }

  return (
    <div
      style={{
        height: "calc(100vh - 50px)",
        width: "100%",
      }}
    >
      <div id="location-members" style={{ height: "calc(100vh - 50px)" }}>
        <div ref={mapElement} style={{ height: "100%" }}></div>
        {renderMenuBtn()}
        {openPopup && renderPopup()}
        {openPopupMenu && (
          <PopupZones
            zoneList={zoneList}
            onClose={handleClickZoneCloseBtn}
            onSelect={handleSelectZone}
            isPopupInfoOpen={openPopup}
          />
        )}
      </div>
    </div>
  );
};

export default LocationContent;
